import { getDateFromDateAndTime } from '@percent/cause-dashboard/common/utility/getDateFromDateAndTime'

export const formatStartEndDate = (
  date?: [Date | null | undefined, Date | null | undefined],
  startTime?: string,
  endTime?: string
) => {
  let startDate = null
  let endDate = null

  if (date?.some(d => !!d) && startTime?.split(':').length && endTime?.split(':').length) {
    startDate = getDateFromDateAndTime(date[0] as Date, startTime)
    endDate = getDateFromDateAndTime(date[1] as Date, endTime)
  }

  return { startDate, endDate }
}
